{
  "fr": {
    "incognito": {
      "signedInAs": "Connecté en tant que",
      "stop": "Quitter"
    }
  }
}
